import React from 'react';
import useWizardContext from '../../hooks/useWizardContext';

const Peek: React.FC = () => {
  const ctx = useWizardContext();
  return (
    <div style={{ backgroundColor: 'lightgoldenrodyellow', bottom: 0, position: 'absolute', right: 0 }}>
      <pre style={{ textAlign: 'start' }}>
        <h2>PEEK:</h2>
        <code>{JSON.stringify(ctx, null, 2)}</code>
      </pre>
    </div>
  );
};
Peek.displayName = 'Peek';

export default Peek;
